import React from "react";
import { Container } from "react-bootstrap";
import { redirect, useLoaderData } from "react-router";

import RegisterCoach from "./RegisterCoach";
import RegisterOrgUser from "./RegisterOrgUser";

import { store } from "../..";
import { globalActions } from "../../features/global/globalSlice";
import { TUserType } from "../../types/forms";

export const loader = async ({ params }: any) => {
    if (
        !params?.userType ||
        !(["coach", "orguser"] as TUserType[]).includes(params.userType)
    ) {
        return redirect("/");
    }

    const {
        global: { settings },
        global: { ageLevels },
    } = store.getState();

    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !ageLevels.length &&
        promises.push(store.dispatch(globalActions.getAgeLevels()));

    await Promise.all(promises);

    return { userType: params.userType };
};

const Register = (): React.JSX.Element => {
    const { userType } = useLoaderData() as {
        userType: TUserType;
    };

    const renderForm = (userType: TUserType): React.JSX.Element => {
        switch (userType) {
            case "coach":
                return <RegisterCoach />;
            case "orguser":
                return <RegisterOrgUser />;
        }
    };

    return (
        <div data-testid="registerContent">
            <Container className="py-5 register">
                {renderForm(userType)}
            </Container>
        </div>
    );
};

export default Register;
